import { CommanderActionDef } from "./redemptionActions";

/**
 * Alerts monitoring dashboard actions (`/alerts-dashboard`).
 * `action_id` keys are stable; `name` / `description` are what GA users read.
 */
export const ALERTS_DASHBOARD_ACTIONS = {
  dashboard_view: {
    name: "View Dashboard",
    description:
      "User opened the Alerts monitoring dashboard and loaded the summary",
  },
  filter_apply: {
    name: "Apply Filters",
    description:
      "User applied date, audience, section, type, severity, customer or status filters",
  },
  filter_clear: {
    name: "Clear Filters",
    description: "User reset the Alerts dashboard filters to the defaults",
  },
  dashboard_refresh: {
    name: "Refresh Dashboard",
    description: "User reloaded the summary with the already applied filters",
  },
  date_preset_select: {
    name: "Select Date Preset",
    description:
      "User picked a quick date chip (7d / 30d / 90d / FY) before Apply",
  },
  date_range_change: {
    name: "Pick Custom Dates",
    description: "User changed the custom date range in draft filters",
  },
  search_panel_toggle: {
    name: "Toggle Search Panel",
    description: "User expanded or collapsed the Search filters panel",
  },
  tab_change: {
    name: "Change Tab",
    description: "User switched between Overview, Emails and Push tabs",
  },
  card_click: {
    name: "Open Metric Card",
    description: "User opened the alerts behind a summary card",
  },
  card_list_click: {
    name: "Open Delivery List",
    description:
      "User opened the push or email delivery list behind a summary card",
  },
  trend_day_click: {
    name: "Open Trend Day",
    description: "User opened the alerts raised on one day of the trend chart",
  },
  type_row_click: {
    name: "Open Alert Type",
    description: "User opened the alerts of one type from the by-type table",
  },
  customer_row_click: {
    name: "Open Customer",
    description:
      "User opened the alerts of one client from the by-customer table",
  },
  list_status_change: {
    name: "Change List Status",
    description: "User changed the status filter on the Emails or Push list",
  },
  alert_open: {
    name: "Open Alert Detail",
    description: "User opened one alert (recipients, timeline, push, email)",
  },
  email_open: {
    name: "Open Email Detail",
    description: "User opened one alert email batch and its SendGrid events",
  },
  recipient_open: {
    name: "Open Recipient",
    description: "User opened everything one admin or client user received",
  },
  detail_tab_change: {
    name: "Change Detail Tab",
    description: "User switched tabs inside an alert detail",
  },
  drawer_back: {
    name: "Drawer Back",
    description: "User went back to the previous view inside the drawer",
  },
  drawer_close: {
    name: "Close Drawer",
    description: "User closed the Alerts dashboard drawer",
  },
  drawer_refresh: {
    name: "Refresh Drawer",
    description: "User reloaded the open drawer view",
  },
  table_sort: {
    name: "Sort Table",
    description: "User sorted a column in a drill-down or list table",
  },
  table_page_change: {
    name: "Change Page",
    description: "User changed page in a drill-down or list table",
  },
  export_csv: {
    name: "Export CSV",
    description: "User exported a drill-down or list table as CSV",
  },
} as const satisfies Record<string, CommanderActionDef>;

export type AlertsDashboardActionId = keyof typeof ALERTS_DASHBOARD_ACTIONS;
